const prefix = 'STAFF_LIST';

export const POPULATE_COUNSELOR_DASHBOARD_FILTERS =
  'POPULATE_COUNSELOR_DASHBOARD_FILTERS';

export const SET_COUNSELOR_DASHBOARD_SEARCH_FILTERS =
  'SET_COUNSELOR_DASHBOARD_SEARCH_FILTERS';

export const POPULATE_COUNSELOR_DASHBOARD_STUDENTS_COUNTS =
  'POPULATE_COUNSELOR_DASHBOARD_STUDENTS_COUNTS';

export const POPULATE_COUNSELOR_DASHBOARD_STUDENTS =
  'POPULATE_COUNSELOR_DASHBOARD_STUDENTS';

export const POPULATE_COUNSELOR_DASHBOARD_STUDENTS_HASH =
  'POPULATE_COUNSELOR_DASHBOARD_STUDENTS_HASH';

export const UPDATE_COUNSELOR_DASHBOARDS_BUSY_RETRIEVING_STUDENTS =
  'UPDATE_COUNSELOR_DASHBOARDS_BUSY_RETRIEVING_STUDENTS';

export const CHANGE_COUNSELOR_DASHBOARD_STUDENTS_PAGE =
  'CHANGE_COUNSELOR_DASHBOARD_STUDENTS_PAGE';

export const CHANGE_COUNSELOR_DASHBOARD_STUDENTS_PER_PAGE =
  'CHANGE_COUNSELOR_DASHBOARD_STUDENTS_PER_PAGE';

export const CHANGE_COUNSELOR_DASHBOARD_SORT_MODE =
  'CHANGE_COUNSELOR_DASHBOARD_SORT_MODE';

export const TOGGLE_ALL_COUNSELOR_DASHBOARD_STUDENTS_SELECTED =
  'TOGGLE_ALL_COUNSELOR_DASHBOARD_STUDENTS_SELECTED';

export const TOGGLE_COUNSELOR_DASHBOARD_STUDENT_SELECTED =
  'TOGGLE_COUNSELOR_DASHBOARD_STUDENT_SELECTED';

export const CHANGE_COUNSELOR_DASHBOARD_STUDENT_SEARCH_TERM =
  'CHANGE_COUNSELOR_DASHBOARD_STUDENT_SEARCH_TERM';

export const POPULATE_COUNSELOR_DASHBOARD_DISTRICT_INFO =
  'POPULATE_COUNSELOR_DASHBOARD_DISTRICT_INFO';

export const SET_COUNSELOR_DASHBOARD_MESSAGE_SENT_STATUS =
  'SET_COUNSELOR_DASHBOARD_MESSAGE_SENT_STATUS';

export const POPULATE_COUNSELOR_DASHBOARD_STUDENT_NOTE_TAGS =
  'POPULATE_COUNSELOR_DASHBOARD_STUDENT_NOTE_TAGS';

export const POPULATE_COUNSELOR_DASHBOARD_STUDENT_NOTES =
  'POPULATE_COUNSELOR_DASHBOARD_STUDENT_NOTES';

export const SET_STUDENT_SELECTED_DASHBOARD = 'SET_STUDENT_SELECTED_DASHBOARD';

export const SET_STUDENT_UNSELECTED_DASHBOARD =
  'SET_STUDENT_UNSELECTED_DASHBOARD';

export const RESET_STUDENT_SELECTED_DASHBOARD =
  'RESET_STUDENT_SELECTED_DASHBOARD';

export const SET_ACTIVE_DASHBOARD_FILTER = 'SET_ACTIVE_DASHBOARD_FILTER';

export const SET_SEARCH_TERM = `${prefix}/SET_SEARCH_TERM`;
